import axios from 'axios'
import { CaseTypeWithLaboratoryInformationResponse, CommonCaseTypeResponse } from '@/api/services/common/case-type/common-case-type.dto'

class CommonCaseTypeService {
    async getActiveCaseTypesByLaboratory(laboratoryId: number): Promise<CaseTypeWithLaboratoryInformationResponse[]> {
        const response = await axios.get<CaseTypeWithLaboratoryInformationResponse[]>(`/common/laboratories/${laboratoryId}/caseTypes`)
        return response.data
    }

    async getCaseTypes(): Promise<CommonCaseTypeResponse[]> {
        const response = await axios.get<CommonCaseTypeResponse[]>(`/common/laboratories/caseTypes`)
        return response.data
    }
}
export const commonCaseTypeService = new CommonCaseTypeService()
